module.exports = __webpack_public_path__ + "static/media/google_cloud-icon.d87afdbb.svg";